import { ENABLE_LCA_FACILITIES_PROTOTYPE_UI } from "../../../config/constants";
import FacilityEditDrawer from "../facilityDrawer/FacilityEditDrawer";
import { FacilityEditModalProps } from "../facilityDrawer/types/facilityDrawer.types";
import FacilityEditModalLegacy from "./legacy/FacilityEditModalLegacy";

const FacilityEditModal = (props: FacilityEditModalProps) =>
  ENABLE_LCA_FACILITIES_PROTOTYPE_UI ? (
    <FacilityEditDrawer {...props} />
  ) : (
    <FacilityEditModalLegacy {...props} />
  );

export default FacilityEditModal;
export type { FacilityEditModalProps };
